<template>
	<b-container v-if="!isLoggedIn" fluid class="page">
		<b-row>
			<b-col lg="4" md="5" class="mh-login-left">
				<div class="mh-login-logo">
					<img src="../assets/images/logo.png" alt="Mopane Health">
				</div>
				<div class="mh-login-content mb-5">
					<h1>Change Password</h1>
					<p>Enter your new password</p>
					<b-form-input type="text" placeholder="Code" v-model="code" autocomplete="off" @keyup.enter="onSubmit()" class="mb-2" />
					<b-form-input type="password" placeholder="New Password" v-model="newPassword" autocomplete="off" @keyup.enter="onSubmit()" class="mb-2" />
					<b-form-input type="password" placeholder="Confirm Password" v-model="confirmPassword" autocomplete="off" @keyup.enter="onSubmit()" class="mb-2" />
					<button class="btn btn-default" @click="changePassword">Change</button>
				</div>
				<div class="mh-register-copyright"><p>&copy; MOPANE HEALTH 2021. All Rights Reserved.</p></div>
			</b-col>
			<b-col lg="8" md="7" class="text-center">
				<div class="mh-login-img">
					<div>
						<img src="../assets/images/login-graphic.png" alt="Login" class="img-fluid">
					</div>
				</div>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	export default {
		name: 'ChangePasswordPage',
		data: function () {
			return {
				code: null,
				newPassword: null,
				confirmPassword: null
			}
		},
		computed: {
			isLoggedIn: function () {
				return this.$store.state.Profile != undefined && this.$store.state.Profile.isLoggedIn
			},
			codeValid: function () {
				if (this.code == null)
					return false

				if (this.code == "")
					return false

				return true
			},
			newPasswordValid: function () {
				if (this.newPassword == null)
					return false

				if (this.newPassword == "")
					return false

				if (this.newPassword != this.confirmPassword)
					return false

				return true
			},
			confirmPasswordValid: function () {
				if (this.confirmPassword == null)
					return false

				if (this.confirmPassword == "")
					return false

				return true
			}
		},
		methods: {
			isFormValid: function () {
				return this.codeValid
					&& this.newPasswordValid
					&& this.confirmPasswordValid
			},
			onSubmit() {
				this.changePassword()
			},
			changePassword: function () {
				if (!this.isFormValid()) {
					this.$store.commit("Toasts/showError", { title: "Login Failed", content: "Please fill in all fields" })

					return
				}

				var credentials = {
					code: this.code,
					newPassword: this.newPassword
				}

				this.$store.dispatch("Profile/changePassword", credentials)
			}
		}
	}
</script>

<style scoped>
	.mh-login-logo img {
		width: 100%;
	}
</style>